<script>
  export let elementId = 'toggle';
  export let label = 'Expand';
  export let hidden = true;
</script>

<button
  class="bttn bttn-invisible d-flex flex-items-center ml-auto px-0"
  type="button"
  aria-controls={`${elementId}-panel`}
  aria-expanded={!hidden}
  data-testid={`${elementId}-toggle`}
  on:click={() => (hidden = !hidden)}
>
  <span>{label}</span>
  <svg
    class="ml-2"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 32 32"
    width="16"
    height="16"
    ><path
      fill="currentColor"
      d="M15.814 0.812L31.564 16.562L26.626 21.5L15.813 10.625L4.938 21.5L0 16.562L15.814 0.812Z"
      transform={hidden ? 'rotate(180 16 16)' : null}
    /></svg
  >
</button>
<div id={elementId} class:d-none={hidden} data-testid={`${elementId}-panel`}>
  <slot />
</div>
